import React, { useRef, useState } from 'react';
import isEqual from 'react-fast-compare';
import { useIntl } from '@utils/localize';
import get from 'lodash/get';

import colors from '@utils/colors';
import Checkbox from '@components/Checkbox';
import Container from '@components/Container';
import { Close, Filter, Search } from '@components/Icon';
import { Heading } from '@components/type';
import * as styled from './styles';

function Mobile({
  controller,
  handleFilter,
  handleSearch,
  handleSort,
  filters,
  search,
  sort,
}) {
  const intl = useIntl();

  const inputRef = useRef(null);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [searchValue, setSearchValue] = useState(get(search, 'value', ''));

  const closeDrawer = () => {
    handleSearch(searchValue);
    setDrawerOpen(false);
  };

  const openDrawer = () => {
    setDrawerOpen(true);
  };

  const handleSearchSubmit = () => {
    handleSearch(searchValue);
    setDrawerOpen(false);

    if (get(inputRef, 'current')) {
      inputRef.current.blur();
    }
  };

  const handleSearchChange = (evt) => {
    setSearchValue(evt.target.value);
  };

  const handleKeyDown = (evt) => {
    if (evt.keyCode === 13) {
      handleSearchSubmit();
    }
  };

  const searchInputProps = {
    onChange: handleSearchChange,
    onKeyDown: handleKeyDown,
    placeholder: search.placeholder || search.title,
    value: searchValue,
    ref: inputRef,
  };

  return (
    <>
      <styled.Drawer open={drawerOpen} onClick={closeDrawer}>
        <styled.Inner
          open={drawerOpen}
          onClick={(evt) => evt.stopPropagation()}
        >
          <styled.Header>
            <Heading level={400}>{intl.formatMessage({ id: 'filters' })}</Heading>
            <styled.CloseButton onClick={closeDrawer}>
              <Close size={18} />
            </styled.CloseButton>
          </styled.Header>
          <styled.Search>
            <styled.SearchInput {...searchInputProps} />
            <styled.SearchButton onClick={handleSearchSubmit}>
              <Search color={colors.B500} />
            </styled.SearchButton>
          </styled.Search>
          {(filters || []).map((filter, idx) => {
            const filterValues = get(
              controller,
              `state.filter['${filter.key}']`,
              [],
            );

            return (
              <styled.Section key={idx}>
                <styled.Heading level={500}>
                  {filter.title}{' '}
                  {filterValues.length > 0 ? `(${filterValues.length})` : ''}
                </styled.Heading>
                {filter.items.map((item, idx) => (
                  <styled.Item key={idx}>
                    <Checkbox
                      checked={filterValues.includes(item.value)}
                      label={item.name}
                      onChange={() => {
                        handleFilter(filter.key, item.value);
                      }}
                    />
                  </styled.Item>
                ))}
              </styled.Section>
            );
          })}
          {sort && (
            <styled.Section>
              <styled.Heading level={500}>{intl.formatMessage({ id: 'sortBy' })}</styled.Heading>
              {sort.options.map((option, idx) => (
                <styled.Item key={idx}>
                  <Checkbox
                    checked={isEqual(controller.state.sort, option.value)}
                    label={option.name}
                    onChange={() => {
                      handleSort(option.value);
                    }}
                  />
                </styled.Item>
              ))}
            </styled.Section>
          )}
        </styled.Inner>
      </styled.Drawer>
      <Container centered>
        <styled.Wrapper onClick={openDrawer}>
          <styled.Heading level={500}>
            {sort ? intl.formatMessage({ id: 'filterSort' }) : intl.formatMessage({ id: 'filter' })}
          </styled.Heading>
          <Filter color={colors.B500} />
        </styled.Wrapper>
      </Container>
    </>
  );
}

export default Mobile;
